<div class="min-h-screen flex flex-col md:flex-row bg-gray-50 dark:bg-[hsl(215,25%,10%)] dark:text-[hsl(210,15%,90%)]">
  <app-navbar></app-navbar>

  <main class="flex-1 min-w-0 p-8 pt-20 pb-20 md:pt-8 md:pb-8">
    <router-outlet></router-outlet>
  </main>
</div>
